import { graphql } from "gql";
import request from "graphql-request";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const mutationRemoveUsersFn = (
    accessToken: string,
    data: {
        userId: number
    }
) => 
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: mutationQuery,
        variables: {
            userId: data.userId,
        },
        requestHeaders: buildRequestHeaders(accessToken),   
    }).then((data) => {
        if (data) {
            return data;
        }
        throw new Error("Error deleting user");
    })
    .catch((error) => {
        console.error("GraphQL Error:", error);
        throw error; 
    });



const mutationQuery = graphql(`
    mutation removeUser ($userId: Int!) {
        removeUser(userId: $userId){
            userId
        }
    }
`);        

export default mutationRemoveUsersFn;